import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { ESortOder, ESortTypes } from 'reactApp/modules/sort/sort.types';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { RootState } from 'reactApp/store';
import { Sort } from 'reactApp/types/Tree';
import { createSelector } from 'reselect';

export const defaultSort: Sort = {
    type: ESortTypes.name,
    order: ESortOder.asc,
};

const getSortState = (state: RootState) => state.sort;

export const getSortById = createSelector(
    getSortState,
    (state, id: string) => id,
    (state, id): Sort | undefined => state[id]
);

export const getSort = createSelector(
    (state, folder, storage?: EStorageType) => storage || getCurrentStorage(state),
    (state, folder) => folder,
    UserSelectors.getEmail,
    (state, folder) => getSortById(state, folder?.id || ''),
    (storage, folder, email, sort): Sort => {
        if ([EStorageType.start, EStorageType.gallery, EStorageType.feed, EStorageType.albums].includes(storage as EStorageType)) {
            return {
                type: ESortTypes.mtime,
                order: ESortOder.desc,
            };
        }

        if (sort) {
            return sort;
        }

        if (
            storage === EStorageType.trashbin ||
            storage === EStorageType.search ||
            storage === EStorageType.attaches ||
            storage === EStorageType.documents
        ) {
            return {
                type: null,
            };
        }

        if (storage === EStorageType.sharedIncoming) {
            return {
                type: ESortTypes.unmountedFirst,
                order: ESortOder.asc,
            };
        }

        if (storage === EStorageType.sharedAutodelete) {
            return {
                type: ESortTypes.publicExpires,
                order: ESortOder.asc,
            };
        }

        return defaultSort;
    }
);
